import { NewsFeed, NewsPageParameters } from "interfaces/content";
import actionCreatorFactory from "../actionCreatorFactory";

const actionCreator = actionCreatorFactory();

export const fetchFaultNotifications = actionCreator.async<NewsPageParameters, NewsFeed>(
    "FETCH_FAULT_NOTIFICATIONS"
);
